const authSelector = (state) => state.auth;

export default authSelector;